<template>
  <div
    ref="popup"
    class="fixed popup-container primary-transparent-30 rounded-borders text-white q-pa-sm"
    :style="{ left: position.left + 'px', top: position.top + 'px' }"
  >
    <div class="popup-header row justify-between items-center q-mb-sm" @mousedown="startDrag">
      <q-icon name="open_with" size="xs" class="q-mr-sm" />
      <b v-if="headerLabel">{{ headerLabel }}</b>
      <app-button icon="close" size="sm" dense class="transparent q-ml-auto" @click="$emit('close')" />
    </div>
    <slot />
  </div>
</template>

<script setup>
import { ref, onUnmounted, watch, nextTick } from "vue"

const props = defineProps({
  initialPosition: {
    type: Object,
    default: () => ({ left: 0, top: 0 })
  },
  headerLabel: {
    type: String,
    default: null
  }
})

const popup = ref(null)
const position = ref({ left: 0, top: 0 })

let isDragging = false
const dragOffset = { x: 0, y: 0 }

const recalculatePosition = async () => {
  await nextTick()
  const tw = popup.value?.offsetWidth || 0
  const th = popup.value?.offsetHeight || 0
  let left = props.initialPosition.left + 10
  let top = props.initialPosition.top + 10

  if (left + tw > window.innerWidth) {
    left = window.innerWidth - tw - 40
  }
  if (top + th > window.innerHeight) {
    top = window.innerHeight - th - 40
  }

  position.value = { left, top }
}

watch(
  () => props.initialPosition,
  (newPos) => {
    position.value = { left: newPos.left, top: newPos.top }
    recalculatePosition()
  },
  { immediate: true }
)

const startDrag = (event) => {
  if (!popup.value) {
    return
  }
  isDragging = true
  const rect = popup.value.getBoundingClientRect()
  dragOffset.x = event.clientX - rect.left
  dragOffset.y = event.clientY - rect.top

  document.addEventListener("mousemove", onDrag)
  document.addEventListener("mouseup", stopDrag)
}

const onDrag = (event) => {
  if (!isDragging || !popup.value) {
    return
  }
  const left = event.clientX - dragOffset.x
  const top = event.clientY - dragOffset.y
  position.value = { left, top }
}

const stopDrag = () => {
  isDragging = false
  document.removeEventListener("mousemove", onDrag)
  document.removeEventListener("mouseup", stopDrag)
}

onUnmounted(() => stopDrag())
</script>

<style lang="scss" scoped>
.popup-container {
  z-index: 1000;
}

.popup-header {
  cursor: move;
  user-select: none;
}
</style>
